import { useThemeContext } from './ThemeProvider';
import { Tokens, ThemeMode } from '../tokens';

export function useTokens(): Tokens {
  return useThemeContext().tokens;
}

export function useThemeMode(): {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  toggleMode: () => void;
} {
  const { mode, setMode, toggleMode } = useThemeContext();
  return { mode, setMode, toggleMode };
}
